export default {"src":"/_next/static/media/spring.d6304183.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};